import React, { useEffect, useState } from "react";
import CheckBox from "../customInputs/CheckBox";
import { MainContainer } from "./styles";
import { sendExportable } from "./utils";
import CustomButton from "../CustomButton";

const ModalExport = ({
  productsSelected,
  selectedArticles,
  setSelectedArticles,
  exportData,
  addNotification,
  close,
}) => {
  const [generateDatasheet, setGenerateDatasheet] = useState(true);
  const [generateDescriptions, setGenerateDescriptions] = useState(true);
  const [generateImages, setGenerateImages] = useState(true);
  const [exportButtonDisabled, setExportButtonDisabled] = useState(false);
  const [buttonLabel, setButtonLabel] = useState("Exportar");

  const handleCheckboxChange = (event) => {
    const { id, checked } = event.target;

    switch (id) {
      case "chk-datasheets":
        setGenerateDatasheet(checked);
        break;
      case "chk-descriptions":
        setGenerateDescriptions(checked);
        break;
      case "chk-images":
        setGenerateImages(checked);
        break;
      default:
        break;
    }
  };

  useEffect(() => { 
    if (exportButtonDisabled) {
      setButtonLabel("Solicitando...");
    } else {
      setButtonLabel("Exportar");
    }

  }, [exportButtonDisabled])

  return (
    <MainContainer>
      <div className="products-select">
        <p>{productsSelected}</p>
      </div>
      <h1>
        {productsSelected === 1 ? "Producto Elegido" : "Productos Elegidos"}
      </h1>
      <h2>Selecciona entregables</h2>
      <div className="container-services">
        <CheckBox
          id="chk-descriptions"
          label="Descripciones"
          typeColor="purple"
          checked={generateDescriptions}
          onChange={handleCheckboxChange}
        />
        <CheckBox
          id="chk-datasheets"
          label="Ficha técnica"
          typeColor="purple"
          checked={generateDatasheet}
          onChange={handleCheckboxChange}
        />
        <CheckBox
          id="chk-images"
          label="Imágenes"
          typeColor="purple"
          checked={generateImages}
          onChange={handleCheckboxChange}
        />
      </div>
      <h2>Cadena: Office Depot</h2>
      <div className="custom-modal-footer">
        <CustomButton className="btn-regresar" label="Regresar" onClick={close} />
        <CustomButton
          className="btn-exportar"
          label={buttonLabel}
          disabled={exportButtonDisabled}
          onClick={async () => {
            setExportButtonDisabled(true);
            await sendExportable(selectedArticles, exportData, addNotification, {
              generateDatasheet,
              generateDescriptions,
              generateImages,
            });
            setGenerateDatasheet(true);
            setGenerateDescriptions(true);
            setGenerateImages(true);
            setSelectedArticles([]);
            setExportButtonDisabled(false);
            close();
          }}
        /> 
      </div>
      
    </MainContainer>
  );
};

export default ModalExport;
